import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=373874e5&scoped=true&"
import script from "./AddPage.vue?vue&type=script&lang=js&"
export * from "./AddPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=373874e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373874e5",
  null
  
)

export default component.exports